import { render } from "./OnboardingCompanyPage.vue?vue&type=template&id=a566ffce&scoped=true"
import script from "./OnboardingCompanyPage.vue?vue&type=script&lang=js"
export * from "./OnboardingCompanyPage.vue?vue&type=script&lang=js"

import "./OnboardingCompanyPage.vue?vue&type=style&index=0&id=a566ffce&lang=scss"
import "./OnboardingCompanyPage.vue?vue&type=style&index=1&id=a566ffce&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a566ffce"]])

export default __exports__